import { Check } from 'phosphor-react';

interface Step {
  step: number;
  title: string;
  description: string;
  completed: boolean;
  current: boolean;
}

interface StepIndicatorProps {
  steps: Step[];
}

export function StepIndicator({ steps }: StepIndicatorProps) {
  return (
    <div className="sticky top-24">
      {/* Steps List */}
      <div className="space-y-6">
        {steps.map((stepInfo) => (
          <div key={stepInfo.step} className="flex items-start gap-4">
            {/* Icon */}
            <div className="flex-shrink-0">
              {stepInfo.completed ? (
                <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center">
                  <Check className="w-5 h-5 text-white" weight="bold" />
                </div>
              ) : stepInfo.current ? (
                <div className="w-8 h-8 rounded-full bg-[color:var(--nt-primary)] flex items-center justify-center">
                  <span className="text-sm font-semibold text-white">{stepInfo.step}</span>
                </div>
              ) : (
                <div className="w-8 h-8 rounded-full bg-[color:color-mix(in_oklab,var(--card-border)_40%,transparent)] flex items-center justify-center">
                  <span className="text-sm font-semibold theme-text-muted">{stepInfo.step}</span>
                </div>
              )}
            </div>
            {/* Content */}
            <div className="flex-1 min-w-0">
              <div className={`text-sm font-medium ${stepInfo.completed || stepInfo.current ? 'theme-text' : 'theme-text-muted'}`}>
                {stepInfo.title}
              </div>
              <div className="text-xs theme-text-muted mt-1">
                {stepInfo.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
